<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<script lang="ts" setup>
const userStore = useUserStore()
const route = useRoute()

// Public routes that don't require redirecting. Exact paths plus public prefixes
// (e.g. /review/<token>, the no-login client review page).
const publicRoutes = ['/login', '/signup', '/confirm', '/reset-password']
const publicPrefixes = ['/review']
const isPublicPath = (path: string) => publicRoutes.includes(path) || publicPrefixes.some((p) => path.startsWith(p))

// If the route is already in the app directory or is a public route, do nothing
// Otherwise, redirect based on authentication status
onMounted(async () => {
  // Skip for SSR
  if (import.meta.server) return

  // Wait for user status to resolve if it's loading
  if (userStore.loading) {
    await new Promise<void>((resolve) => {
      const unwatch = watch(() => userStore.loading, (isLoading) => {
        if (!isLoading) {
          unwatch()
          resolve()
        }
      })
    })
  }

  // Skip redirection for routes that are already public or in the app directory
  if (route.path.startsWith('/app') || isPublicPath(route.path)) return

  // Root is the public marketing page; only bounce logged-in users into the app.
  if (route.path === '/') {
    if (userStore.isLoggedIn) navigateTo('/app')
    return
  }

  // For any non-app, non-public path, check auth and redirect appropriately
  if (userStore.isLoggedIn) {
    navigateTo(`/app${route.path}`)
  } else {
    navigateTo(`/login?redirect=/app${route.path}`)
  }
})
</script>
